import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const state = () => ({
    isFetchingSummary: false,
    summarySecurityLogs: null,
    summaryError: '',
})

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
